import { EExpenseLevel } from '../../typings'

export const newExpensesRoutes: INewExpenseRoute[] = [
	{ path: '/gastos', component: 'aggregation' },
	{ path: '/gastos/tabla', component: 'list' },
	{ path: '/gastos/tabla/:expenseID', component: 'detail' },
	{ path: '/gastos/:entity', component: 'aggregation' },
	{ path: '/gastos/:entity/tabla', component: 'list' },
	{ path: '/gastos/:entity/tabla/:expenseID', component: 'detail' },
]

export const newExpensesNoHeaderMatchingRegexes: RegExp[] = [
	/^\/gastos\/.*\/tabla\/.*$/i,
]

export interface INewExpenseRoute {
	path: string
	component: 'detail' | 'list' | 'aggregation'
}

export const expensesRoutes: IExpenseRoute[] = [
	{
		path: '/gastos',
		level: EExpenseLevel.Federal,
		component: 'aggregation',
	},
	{
		path: '/gastos/discretos',
		level: EExpenseLevel.Federal,
		component: 'list',
	},
	{
		path: '/gastos/año/:year',
		level: EExpenseLevel.Quarter,
		component: 'aggregation',
	},
	{
		path: '/gastos/discretos/:expenseID',
		level: EExpenseLevel.Federal,
		component: 'detail',
	},
	{
		path: '/gastos/año/:year/discretos',
		level: EExpenseLevel.Federal,
		component: 'list',
	},
	{
		path: '/gastos/año/:year/cuarto/:quarter',
		level: EExpenseLevel.Institution,
		component: 'aggregation',
	},
	{
		path: '/gastos/año/:year/discretos/:expenseID',
		level: EExpenseLevel.Federal,
		component: 'detail',
	},
	{
		path: '/gastos/año/:year/cuarto/:quarter/discretos',
		level: EExpenseLevel.Federal,
		component: 'list',
	},
	{
		path: '/gastos/año/:year/cuarto/:quarter/ministerio/:institution',
		level: EExpenseLevel.Entity,
		component: 'aggregation',
	},
	{
		path: '/gastos/año/:year/cuarto/:quarter/discretos/:expenseID',
		level: EExpenseLevel.Federal,
		component: 'detail',
	},
	{
		path: '/gastos/año/:year/cuarto/:quarter/ministerio/:institution/discretos',
		level: EExpenseLevel.Institution,
		component: 'list',
	},
	{
		path:
			'/gastos/año/:year/cuarto/:quarter/ministerio/:institution/entidad/:entity',
		level: EExpenseLevel.Program,
		component: 'aggregation',
	},
	{
		path:
			'/gastos/año/:year/cuarto/:quarter/ministerio/:institution/discretos/:expenseID',
		level: EExpenseLevel.Institution,
		component: 'detail',
	},
	{
		path:
			'/gastos/año/:year/cuarto/:quarter/ministerio/:institution/entidad/:entity/discretos',
		level: EExpenseLevel.Entity,
		component: 'list',
	},
	{
		path:
			'/gastos/año/:year/cuarto/:quarter/ministerio/:institution/entidad/:entity/discretos/:expenseID',
		level: EExpenseLevel.Entity,
		component: 'detail',
	},
	{
		path:
			'/gastos/año/:year/cuarto/:quarter/ministerio/:institution/entidad/:entity/programa/:program',
		level: EExpenseLevel.Program,
		component: 'list',
	},
	{
		path:
			'/gastos/año/:year/cuarto/:quarter/ministerio/:institution/entidad/:entity/programa/:program/:expenseID',
		level: EExpenseLevel.Program,
		component: 'detail',
	},
]

export const expensesNoHeaderMatchingRegexes: RegExp[] = [
	/^\/gastos\/discretos\/.*$/i,
	/^\/gastos\/año\/.*\/discretos\/.*$/i,
	/^\/gastos\/año\/.*\/cuarto\/.*\/discretos\/.*$/i,
	/^\/gastos\/año\/.*\/cuarto\/.*\/ministerio\/.*\/discretos\/.*$/i,
	/^\/gastos\/año\/.*\/cuarto\/.*\/ministerio\/.*\/entidad\/.*\/discretos\/.*$/i,
	/^\/gastos\/año\/.*\/cuarto\/.*\/ministerio\/.*\/entidad\/.*\/programa\/.*$/i,
	/^\/gastos\/año\/.*\/cuarto\/.*\/ministerio\/.*\/entidad\/.*\/programa\/.*\/.*$/i,
]

export interface IExpenseRoute {
	path: string
	level: EExpenseLevel
	component: 'detail' | 'list' | 'aggregation'
}
